module.exports = __webpack_public_path__ + "28350cad9536c56cecc2c23a30d358ee.png";